// extracted by mini-css-extract-plugin
export default {"headerTabs":"styles_headerTabs__3l-Tm","searchInput":"styles_searchInput__j7URw"};